import angular from "angular";
import FoodPrepTimeComponent from "./foodPrepTime.component";
import FoodPrepTimeService from "./foodPrepTime.service";
import foodPrepTimeStepperTemplate from "./page/foodPrepTimeStepper.html";

const foodPrepTimeModule = angular
  .module("foodPrepTime", [])
  .component("foodPrepTime", FoodPrepTimeComponent)
  .service("foodPrepTimeService", FoodPrepTimeService)
  .directive("foodPrepTimeStepper", function () {
    return {
      template: foodPrepTimeStepperTemplate,
      scope: {
        ctrl: "=",
      },
    };
  }).name;

export default foodPrepTimeModule;



// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTime.js